/* eslint-disable */
import Validate from "./validate"
// 手机号
const mobile = {
  trigger: "blur",
  required: true,
  placeholder: "中国大陆手机号格式",
  noneMessage: "手机号不能为空"
}
// 国际手机号
const interMobile = {
  trigger: "blur",
  required: true,
  placeholder: "请输入手机号",
  noneMessage: "手机号不能为空"
}
// 密码
const password = {
  trigger: "blur",
  required: true,
  placeholder: "请输入密码（8-20位数字和字母组合）",
  noneMessage: "密码不能为空"
}
//验证码
const verifyCode = {
  trigger: "blur",
  required: true,
  placeholder: "请输入验证码",
  noneMessage: "请输入验证码"
}
// 单行文本
function textNum(min, max) {
  return {
    trigger: "blur",
    required: false,
    min: min,
    max: max
  }
}

// 字符长度
function charNumRangeValidate(options) {
  let validates = [
    {
      min: options.min,
      max: options.max,
      message:
        options.min === 0
          ? "最多输入" + options.max + "个字符"
          : (options.message ? options.message : "请输入" + options.min + "-" + options.max + "个字符"),
      trigger: options.trigger
    }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}

// 数值类型
function number(minVal, maxVal) {
  return {
    trigger: "blur",
    required: false,
    minVal: minVal,
    maxVal: maxVal
  }
}

// 范围，两位小数
function numRangeValidate(options) {
  let validates = [
    { validator: Validate.validateNum, trigger: options.trigger },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value, callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    },
    { validator:(rule, value, callback) =>
        Validate.validateNumberBits(rule, value, callback, {bit: options.bit || 2}), trigger: options.trigger }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}

// 范围，一位小数
function numRangeOneFloatValidate(options) {
  let validates = [
    { validator: Validate.validateNum, trigger: options.trigger },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value, callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    },
    { validator: Validate.validateOneFloat, trigger: options.trigger }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}
// 范围，三位小数
function numRangeThreeFloatValidate(options) {
  let validates = [
    { validator: Validate.validateNum, trigger: options.trigger },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value, callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    },
    { validator: Validate.validateThreeFloat2, trigger: options.trigger }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}
// 范围，四位小数
function numRangeFourFloatValidate(options) {
  let validates = [
    { validator: Validate.validateNum, trigger: options.trigger },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value, callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    },
    { validator: Validate.validateFourFloat, trigger: options.trigger }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}
// 范围，五位小数
function numRangeFiveFloatValidate(options) {
  let validates = [
    { validator: Validate.validateNum, trigger: options.trigger },
    {
      validator: (rule, value, callback) =>
          Validate.validateValueRange(rule, value, callback, {
            min: options.minVal,
            max: options.maxVal,
            message: options.message
          }),
      trigger: options.trigger
    },
    { validator: Validate.validateFiveFloat, trigger: options.trigger }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
          Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}
// 范围，整数
function integerRangeValidate(options) {
  let validates = [
    { validator:(rule,value,callback) =>
        Validate.validateNum(rule,value,callback,{
          message:options.message
        }),
      trigger: options.trigger
    },
    { validator: (rule,value,callback) =>
        Validate.validateInteger(rule,value,callback,{message:options.message})
      , trigger: options.trigger
    },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value, callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}
// 范围，整数（严格校验）
function integerStrictRangeValidate(options) {
  let validates = [
    { validator:(rule,value,callback) =>
        Validate.validateStrictNum(rule,value,callback,{
          message:options.message
        }),
      trigger: options.trigger
    },
    { validator: (rule,value,callback) =>
        Validate.validateInteger(rule,value,callback,{message:options.message})
      , trigger: options.trigger
    },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value, callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}
// 日期类型
const dateType = {
  trigger: "blur",
  required: false
}
// 时间类型
const timeType = {
  trigger: "blur",
  required: false
}

// =============export==================
// 手机号
export const vMobile = args => {
  const options = Object.assign({}, mobile, args)
  let validates = [
    { validator: Validate.validateMobile, trigger: options.trigger }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}

export const vInterMobile = args => {
  const options = Object.assign({}, interMobile, args)
  let validates = [
    {
      validator: (rule, value, callback) =>
        Validate.validateInternationalMobile(
          rule,
          value,
          callback,
          options.condition
        ),
      trigger: options.trigger
    }
  ]
  if (options.required) {
    validates.unshift({
      validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}

 //TODO:delete,请使用xin-core里的方法
// 密码
export const vPassword = args => {
  const options = Object.assign({}, password, args)
  return {
    validates: [
      {
        validator: (rule, value, callback) =>
          Validate.validateRequired(rule, value, callback, options.noneMessage),
        trigger: options.trigger
      },
      { validator: Validate.validatePass, trigger: options.trigger }
    ],
    config: options
  }
}

// 验证码 6位
export const vVerifyCode = args => {
  const options = Object.assign({}, verifyCode, args)
  return {
    validates: [
      {
        validator: (rule, value, callback) =>
          Validate.validateRequired(rule, value, callback, options.noneMessage),
        trigger: options.trigger
      },
      { validator: Validate.validateVerifyCode, trigger: options.trigger }
    ],
    config: options
  }
}
// 验证码
export const vVerifyCode4 = args => {
  const options = Object.assign({}, verifyCode, args)
  return {
    validates: [
      {
        validator: (rule, value, callback) =>
          Validate.validateRequired(rule, value, callback, options.noneMessage),
        trigger: options.trigger
      },
      { validator: Validate.validateVerifyCode4, trigger: options.trigger }
    ],
    config: options
  }
}

export const vTextNum = args => {
  const options = Object.assign({}, args)
  return charNumRangeValidate(options)
}
export const vText4 = args => {
  const options = Object.assign({}, textNum(0, 4), args)
  return charNumRangeValidate(options)
}
export const vText10 = args => {
  const options = Object.assign({}, textNum(0, 10), args)
  return charNumRangeValidate(options)
}
export const vText15 = args => {
  const options = Object.assign({}, textNum(0, 15), args)
  return charNumRangeValidate(options)
}
export const vText20 = args => {
  const options = Object.assign({}, textNum(0, 20), args)
  return charNumRangeValidate(options)
}
export const vText25 = args => {
  const options = Object.assign({}, textNum(0, 25), args)
  return charNumRangeValidate(options)
}
export const vText30 = args => {
  const options = Object.assign({}, textNum(0, 30), args)
  return charNumRangeValidate(options)
}
export const vText40 = args => {
  const options = Object.assign({}, textNum(0, 40), args)
  return charNumRangeValidate(options)
}
export const vText50 = args => {
  const options = Object.assign({}, textNum(0, 50), args)
  return charNumRangeValidate(options)
}
export const vTextArea100 = args => {
  const options = Object.assign({}, textNum(0, 100), args)
  return charNumRangeValidate(options)
}
export const vTextArea200 = args => {
  const options = Object.assign({}, textNum(0, 200), args)
  return charNumRangeValidate(options)
}
export const vTextArea300 = args => {
  const options = Object.assign({}, textNum(0, 300), args)
  return charNumRangeValidate(options)
}
export const vTextArea500 = args => {
  const options = Object.assign({}, textNum(0, 500), args)
  return charNumRangeValidate(options)
}
export const vTextArea1000 = args => {
  const options = Object.assign({}, textNum(0, 1000), args)
  return charNumRangeValidate(options)
}
export const vTextArea3000 = args => {
  const options = Object.assign({}, textNum(0, 3000), args)
  return charNumRangeValidate(options)
}
export const vTextArea10000 = args => {
  const options = Object.assign({}, textNum(0, 10000), args)
  return charNumRangeValidate(options)
}
export const vNumRangeCustom = args => {
  const options = Object.assign({}, number(-Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER), {bit: 2}, args)
  return numRangeValidate(options)
}

export const vNumRange10 = args => {
  const options = Object.assign({}, number(0, 1000000000), args)
  return numRangeValidate(options)
}

export const vNumRange9 = args => {
  const options = Object.assign({}, number(0, 100000000), args)
  return numRangeValidate(options)
}

export const vNumRange8 = args => {
  const options = Object.assign({}, number(0, 10000000), args)
  return numRangeValidate(options)
}
export const vNumRange8Negative = args => {
  const options = Object.assign({}, number(-10000000, 10000000), args)
  return numRangeValidate(options)
}
export const vNumRange7 = args => {
  const options = Object.assign({}, number(0, 10000000), args)
  return numRangeValidate(options)
}
export const vNumRange6 = args => {
  const options = Object.assign({}, number(0, 100000), args)
  return numRangeValidate(options)
}
// 权重
export const vNumRange3 = args => {
  const options = Object.assign({}, number(0, 100), args)
  return numRangeValidate(options)
}
export const vNumRange4 = args => {
  const options = Object.assign({}, number(0, 1000), args)
  return numRangeValidate(options)
}

//自定义数字范围
export const vNumRangeCustomize = args => {
  const options = Object.assign({}, number(args.min, args.max), args)
  return numRangeValidate(options)
}

//自定义整数数字范围
export const vNumIntegerRangeCustomize = args => {
  const options = Object.assign({}, number(args.min, args.max), args)
  return integerRangeValidate(options)
}

// 一位小数的数字范围
export const vNumOneFloatRange = args => {
  const options = Object.assign({}, number(0, 500), args)
  return numRangeOneFloatValidate(options)
}
// 一位小数的自定义数字范围
export const vNumOneFloatCustomRange = ({min, max}, args) => {
  const options = Object.assign({}, number(min, max), args);
  return numRangeOneFloatValidate(options)
}
// 两位小数的数字范围
export const vNumTwoFloatRange = args => {
  const options = Object.assign({}, number(0, 500), args)
  return numRangeValidate(options)
}
// 四位小数的数字范围
export const vNumFourFloatRange = args => {
  const options = Object.assign({}, number(0, 100000000), args)
  return numRangeFourFloatValidate(options)
}

/**
   * 范围输入框专用 两位小数的数字范围
   * @param args
   */
 export const vNumTwoFloatRangeForRangeInput = args => {
  const options = Object.assign({}, number(0, 500), args);
  const validates = [
    {
      validator: (rule, value, callback) => Validate.validateNum(rule, value[0], callback, {
        message: options.message
      }),
      trigger: options.trigger
    },
    {
      validator: (rule, value, callback) => Validate.validateNum(rule, value[1], callback, {
        message: options.message
      }),
      trigger: options.trigger
    },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value[0], callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value[1], callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    },
    {
      validator: (rule, value, callback) => Validate.validateTwoFloat(rule, value[0], callback),
      trigger: options.trigger
    },
    {
      validator: (rule, value, callback) => Validate.validateTwoFloat(rule, value[1], callback),
      trigger: options.trigger
    },
  ];
  // if (options.required) {
  //   validates.unshift({
  //     validator: (rule, value, callback) =>
  //       Validate.validateRequired(rule, value[0], callback, options.noneMessage),
  //     trigger: options.trigger
  //   }, {
  //     validator: (rule, value, callback) =>
  //       Validate.validateRequired(rule, value[1], callback, options.noneMessage),
  //     trigger: options.trigger
  //   });
  // }
  return {
    validates,
    config: options
  };
}

// 五位小数的数字范围
export const vNumFiveFloatRange = args => {
  const options = Object.assign({}, number(0, 100000000), args)
  return numRangeFiveFloatValidate(options)
}

// 三位小数的数字范围
export const vNumThreeFloatRange = args => {
  const options = Object.assign({},number(0,100000000),args)
  return numRangeThreeFloatValidate(options);
}
// 整数的数字范围
export const vNumIntegerRange = args => {
  const options = Object.assign({}, number(0, 100), args)
  return integerRangeValidate(options)
}
// 整数的数字范围（严格校验）
export const vNumStrictIntegerRange = args => {
  const options = Object.assign({}, number(0, 100), args)
  return integerStrictRangeValidate(options)
}
export const vDate = args => {
  const options = Object.assign({}, dateType, args)
  return {
    validates: [
      {
        // type: "date",
        required: options.required,
        message: "请选择日期",
        trigger: options.trigger
      }
    ],
    config: options
  }
}
export const vTime = args => {
  const options = Object.assign({}, timeType, args)
  const validator = options.required ? (rule, val, cb) => {
    Validate.validateRequired(rule, val, cb)
  } : (rule, val, cb) => {
    cb()
  }
  return {
    validates: [
      {
        validator,
        trigger: options.trigger
      }
    ],
    config: options
  }
}
// 必填 (有样式)
export const vRequired = args => {
  const initRequired = { required: true, trigger: "blur", type: "string"}
  const options = Object.assign({}, initRequired, args)
  return {
    validates: [
      {
        type: options.type,
        required: options.required,
        message: options.message ? options.message : "不能为空",
        trigger: options.trigger
      }
    ],
    config: options
  }
}
// 必填 (没有 *)
export const vRequiredNoStyle = args => {
  const initRequired = { trigger: "blur" }
  const options = Object.assign({}, initRequired, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          Validate.validateRequired(rule, val, cb, options.message)
        },
        trigger: options.trigger
      }
    ],
    config: options
  }
}

// 附件必填校验 (校验文件需要将模板文件排除) flag 0-普通文件 1-模板文件
export const vRequiredFileNoStyle = args => {
  const initRequired = { trigger: "blur" }
  const options = Object.assign({}, initRequired, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          const value = val ? val.filter(item => !item.flag):[];
          Validate.validateRequired(rule, value, cb, options.message)
        },
        trigger: options.trigger
      }
    ],
    config: options
  }
}

// 必填 (没有 *)
export const vSelectNoStyle = args => {
  const initRequired = { trigger: ["change", "blur"]}
  const options = Object.assign({}, initRequired, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          Validate.validateRequired(rule, val, cb, options.message)
        },
        trigger: options.trigger
      }
    ],
    config: options
  }
}

// 选项不为空
export const vSelect = args => {
  const initRequired = { required: true, trigger: ["change", "blur"] }
  const options = Object.assign({}, initRequired, args)
  return {
    validates: [
      {
        required: options.required,
        message: options.message ? options.message : "不能为空",
        trigger: options.trigger
      }
    ],
    config: options
  }
}

//邮箱
export const vEmail = args => {
  const options = Object.assign({}, args)
  let validates = [
        {
          validator: (rule, val, cb) => {
          Validate.validateEmail(rule, val, cb)
        },
      trigger: "blur"
      }
    ]
  if (options.required) {
    validates.unshift({
        validator: (rule, value, callback) =>
        Validate.validateRequired(rule, value, callback, options.noneMessage),
        trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}
// 身份证号
export const vIdCard = args => {
  const options = Object.assign({}, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          Validate.IdCardVerify(rule, val, cb)
        },
        trigger: "blur"
      }
    ],
    config: options
  }
}
// 银行卡
export const vBankCard = args => {
  const options = Object.assign({}, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          Validate.bankCardVerify(rule, val, cb)
        },
        trigger: "blur"
      }
    ],
    config: options
  }
}
//生日
export const vBirthday = args => {
  const options = Object.assign({}, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          Validate.birthdayVerify(rule, val, cb)
        },
        trigger: "blur"
      }
    ],
    config: options
  }
}

// 正整数
export const vPositiveNumber = args => {
  const init = { required: false, trigger: "blur" }
  const options = Object.assign({}, init, args)
  return {
    validates: [
      {
        required: options.required,
        message: options.noneMessage ? options.noneMessage : "不能为空",
        trigger: options.trigger
      },
      { validator: Validate.verifyPositiveNumber, trigger: options.trigger }
    ],
    config: options
  }
}
// 自然数
export const vNaturalIntegers = args => {
  const init = { required: false, trigger: "blur" }
  const options = Object.assign({}, init, args)
  return {
    validates: [
      {
        required: options.required,
        message: options.noneMessage ? options.noneMessage : "不能为空",
        trigger: options.trigger
      },
      { validator: Validate.validateNaturalIntegers, trigger: options.trigger }
    ]
  }
}

// 链接
export const vLinkUrl = args => {
  const options = Object.assign({}, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          Validate.linkUrlValid(rule, val, cb)
        },
        trigger: "blur"
      }
    ],
    config: options
  }
}

// QQ
export const vQQ = args => {
  const options = Object.assign({}, args)
  return {
    validates: [
      {
        validator: (rule, val, cb) => {
          Validate.validateQQ(rule, val, cb)
        },
        trigger: "blur"
      }
    ],
    config: options
  }
}

// 正整数范围
export const vIntegerRange = args => {
  const init = {
    required: false,
    trigger: "blur"
  }
  const options = Object.assign({}, init, args)
  let validates = [
    { validator: Validate.validateNum, trigger: options.trigger },
    { validator: Validate.verifyPositiveNumber, trigger: options.trigger },
    {
      validator: (rule, value, callback) =>
        Validate.validateValueRange(rule, value, callback, {
          min: options.minVal,
          max: options.maxVal,
          message: options.message
        }),
      trigger: options.trigger
    }
  ]

  if (options.required) {
    validates.unshift({
        validator: (rule, value, callback) =>
      Validate.validateRequired(rule, value, callback, options.noneMessage),
      trigger: options.trigger
    })
  }
  return {
    validates,
    config: options
  }
}

